/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2019. All Rights Reserved.
#*
#*===================================================================
*/

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { ServerResponseModel } from 'app/shared/models/serverResponse.model';

@Injectable({ providedIn: 'root' })
export class SmsService {
  constructor(private httpClient: HttpClient) {}

  sendMessage(payload: { to: string; message: string }) {
    return this.httpClient.post(`${environment.apiHostname}/v1/sms/send-sms`, payload).pipe(
      map((response: any) => {
        if (response.result.success) {
          return response.data;
        } else {
          if (
            response.result &&
            response.result.message &&
            response.result.message.code &&
            response.result.message.code === 21610
          ) {
            return { errorMessage: response.result.message.message };
          }
          return { errorMessage: 'An error occured while trying to send message' };
        }
      })
    );
  }

  getPhoneSubscription(phoneNo: string): Observable<any> {
    return this.httpClient
      .get(`${environment.apiHostname}/v1/sms/user-phone-phone-no/${phoneNo}`)
      .pipe(map(this.handleServerResponse));
  }

  getPhoneSubscriptionByUserId(userId: number): Observable<any> {
    return this.httpClient
      .get(`${environment.apiHostname}/v1/sms/user-phone-user-id/${userId}`)
      .pipe(map(this.handleServerResponse));
  }

  addPhoneSubscription(payload: { userId: number; phoneNo: string; action: any }): Observable<any> {
    const data = { ...payload, action: JSON.stringify(payload.action) };
    return this.httpClient.post(`${environment.apiHostname}/v1/sms/add-phone-no`, data).pipe(
      map((response: any) => {
        if (response.result.success) {
          return response.data;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }

  private handleServerResponse = (response: ServerResponseModel) => {
    if (response.result.success) {
      return response.data;
    } else {
      throw new Error(response.result.message);
    }
  };
}
